export async function ptlConfirmOrdersUseCase(trace_id, shipmentRepository) {
    
    const result = await shipmentRepository.ptl_confirm_orders(trace_id);

    return result;
}